<template>
  <v-layout>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary">
        <v-card-text>
          {{ $t("Please Wait") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="snackbarColor"
      top
      multi-line
    >
      {{ $t(snackbarMessage) }}
      <v-btn flat @click="snackbar = false">
        {{ $t("Close") }}
      </v-btn>
    </v-snackbar>

    <!-- Alert Dialog Box -->
    <div class="text-xs-center">
      <v-dialog v-model="dialog" width="500" color="white">
        <v-card class="dialog elevation-10">
          <div>
            <v-flex pa-2 xs12 sm12 md12 lg12 d-flex>
              <v-flex md4>
                <img
                  src="../assets/loudspeaker.svg"
                  class="alert-loudspeaker"
                />
              </v-flex>
              <v-flex md8>
                <v-card-title class="pa-0 pt-2 title font-weight-bold"
                  >{{ $t("Hey, Wait") }}!!</v-card-title
                >
                <v-card-text class="pa-0 pt-3 subheading font-weight-light">{{
                  $t(dialogMessage)
                }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error darken-1" @click="dialog = false">
                    {{ $t("Disagree") }}
                  </v-btn>

                  <v-btn
                    v-if="!isDelete"
                    color="green darken-1"
                    @click="dialog = false"
                  >
                    {{ $t("Agree") }}
                  </v-btn>
                  <v-btn
                    v-if="isDelete"
                    color="green darken-1"
                    @click="
                      isDelete ? deleteTemplate() : (isDelete = false);
                      dialog = false;
                    "
                  >
                    {{ $t("Agree") }}
                  </v-btn>
                </v-card-actions>
              </v-flex>
            </v-flex>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <!-- Alert Dialog Box -->

    <!-- Saving Template Dialog -->
    <div>
      <v-dialog v-model="template" width="300" color="white">
        <v-card class="dialog2">
          <div class="overlay-img">
            <img src="../assets/diskette.svg" />
          </div>
          <v-divider class="divison"></v-divider>
          <v-flex xs12 md12 lg12 d-flex>
            <v-layout wrap>
              <v-flex md12>
                <v-card-title class="pa-2 title justify-center">{{
                  $t("SAVE TEMPLATE")
                }}</v-card-title>
                <v-text-field
                  v-model="name"
                  class="pa-6 input-field"
                  :label="$t('Enter Template Name')"
                  :rules="nameRules"
                  single-line
                  outline
                ></v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="template = false">
                    {{ $t("CANCEL") }}
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="
                      template = false;
                      insertTemplate();
                    "
                  >
                    {{ $t("SAVE") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-dialog>
    </div>
    <!-- Saving Template Dialog -->

    <!-- Push graph to plant overview graph Dialog -->
    <div>
      <v-dialog v-model="isPopDialog" width="300" color="white">
        <v-card class="dialog2">
          <div class="overlay-img">
            <img src="../assets/diskette.svg" />
          </div>
          <v-divider class="divison" />
          <v-flex xs12 md12 lg12 d-flex>
            <v-layout wrap>
              <v-flex md12>
                <v-card-title class="pa-2 title justify-center">{{
                  $t("Push Graph parameters to POP")
                }}</v-card-title>
                <v-text-field
                  v-model="graphName"
                  :label="$t('Graph Name')"
                  flat
                  solo-inverted
                  hide-details
                ></v-text-field>
                <v-select
                  :items="['left', 'right']"
                  v-model="graphPosition"
                  :label="$t('Select Position of Graph')"
                  required
                ></v-select>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="error" @click="isPopDialog = false">
                    {{ $t("CANCEL") }}
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="
                      isPopDialog = false;
                      sendGraphToPop();
                    "
                  >
                    {{ $t("SAVE") }}
                  </v-btn>
                  <v-spacer />
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-dialog>
    </div>
    <!-- Push graph to plant overview graph Dialog -->

    <!-- Side Toggle Button -->
    <div class="vertical-button-container">
      <p
        class="vertical-button"
        @click="levelChange('device')"
      >
        {{ $t("Plant Analogue") }}
      </p>
      <p
        class="vertical-button"
        @click="levelChange('kpi')"
      >
        {{ $t("Plant KPI's") }}
      </p>
    </div>
    <!-- End Side Toggle Button -->

    <!-- Side Bar -->
    <v-layout pl-2 row fill-height v-show="showSideBar">
      <v-flex xs4>
        <Card color="equipment-header" class="pa-2">
          <v-layout column>
            <v-flex xs12 class="bs pt-2 pb-2">
              <p class="fs-16">
                {{ $t("Select Plants/Devices") }}
              </p>
              <v-sheet class="search-area">
                <v-text-field
                  v-model="searchPlant"
                  :label="$t('Search Plant')"
                  flat
                  solo-inverted
                  hide-details
                  clearable
                  icon="mdi-close-circle-outline"
                ></v-text-field>
              </v-sheet>
            </v-flex>
            <v-flex>
              <v-treeview
                :key="'param-tree-' + compKey"
                :search="searchPlant"
                class="trees"
                selectable
                v-model="selectedDevices"
                :items="computedItems"
                :load-children="fetchPlantDeviceConfig"
                open-on-click
                return-object
                loading-icon="mdi-loading"
                @input="handleSelectionChange"
              >
              </v-treeview>
            </v-flex>
          </v-layout>
        </Card>
      </v-flex>
      <v-flex xs4>
        <Card color="parameter-header" class="pa-2">
          <v-layout column>
            <v-flex class="bs pt-2 pb-2">
              <p class="fs-16">
                {{ $t("Select Parameters")
                }}<span class="kpi-note" v-if="level === 'kpi'"
                  >**{{ $t("NOTE") }}:
                  {{ $t("KPI's are inverter based") }}**</span
                >
              </p>
              <v-sheet class="search-area">
                <v-text-field
                  v-model="searchDevice"
                  :label="$t('Search Device')"
                  flat
                  solo-inverted
                  hide-details
                  clearable
                  icon="mdi-close-circle-outline"
                ></v-text-field>
              </v-sheet>
            </v-flex>
            <v-flex>
              <v-treeview
                :key="'param-tree-' + compKey"
                :search="searchDevice"
                class="trees"
                v-model="selectedParameter"
                selectable
                :items="computedParamItems"
                loading-icon="mdi-loading"
                open-on-click
                return-object
              >
              </v-treeview>
            </v-flex>
          </v-layout>
        </Card>

        <div class="btn-centre"></div>
      </v-flex>
      <v-flex xs4>
        <Card color="selected_item_data-header" class="pa-2">
          <v-layout column>
            <v-flex class="bs pa-2">
              <v-layout justify-space-between align-center>
                <v-flex shrink>
                  <p class="fs-16">
                    {{ $t("Selected Items") }}
                  </p>
                </v-flex>
                <v-flex shrink class="equipment-img">
                  <v-tooltip bottom>
                    <img
                      src="../assets/remove_file.svg"
                      slot="activator"
                      class="stand"
                      height="18px"
                      @click="clearSelection"
                    />
                    <span>{{ $t("Clear Selection") }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex>
              <div class="tree" :key="compKey">
                <div v-for="(item, index) in param['query']" :key="item.id">
                  <div class="main-background" avatar ripple>
                    <div class="selected-background">
                      <div class="body-2 orange--text">{{ item.name }}</div>
                      <div
                        class="body-2"
                        v-for="param in item.query"
                        :key="param.name"
                      >
                        {{ param.device }}-{{ param.name
                        }}<span v-if="level == 'kpi'">-{{ param.source }}</span>
                        <div
                          class="body-1 font-weight-thin param"
                          v-for="name in param['paramName']"
                          :key="name"
                        >
                          {{ $t(name) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-divider
                    class="divison"
                    v-if="index + 1 < param.length"
                    :key="index"
                  ></v-divider>
                </div>
              </div>

              <div class="btn-centre">
                <v-menu transition="slide-y-transition" bottom>
                  <v-tooltip top slot="activator">
                    <v-btn class="ntb primaryText" outline slot="activator">
                      {{ $t("RETRIEVE") }}
                      <v-icon right>restore_page</v-icon>
                    </v-btn>
                    <span>{{ $t("Retrieve the Saved Templates") }}</span>
                  </v-tooltip>
                  <v-list v-if="level != '' && templateList[level].length > 0">
                    <v-list-tile
                      class="list_beautify"
                      v-for="(item, i) in templateList[level]"
                      :key="i"
                    >
                      <v-list-tile-title
                        @click="templateSelected(item.value)"
                        >{{ item.text }}</v-list-tile-title
                      >
                      <v-icon
                        small
                        color="error"
                        right
                        @click="
                          dialogMessage =
                            'Are you sure, you wanna delete this template';
                          dialog = true;
                          isDelete = true;
                          deleteId = item.id;
                        "
                      >
                        clear</v-icon
                      >
                    </v-list-tile>
                  </v-list>
                </v-menu>

                <v-tooltip top>
                  <v-btn
                    outline
                    :disabled="param['query'].length === 0 ? true : false"
                    class="ntb primaryText"
                    slot="activator"
                    small
                    @click="loadData"
                    >{{ $t("VIEW") }}
                    <v-icon right>insert_chart</v-icon>
                  </v-btn>
                  <span>{{ $t("Plot Graph/Table") }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    outline
                    :disabled="param['query'].length === 0 ? true : false"
                    class="ntb primaryText"
                    slot="activator"
                    small
                    @click="templateRules()"
                    >{{ $t("SAVE") }}
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <span>{{ $t("Save As Template") }}</span>
                </v-tooltip>
                <v-tooltip top v-show="level !== 'kpi'">
                  <v-btn
                    outline
                    :disabled="
                      param['query'].length === 0 ? true : !isShowPopButton
                    "
                    class="ntb primaryText"
                    slot="activator"
                    small
                    @click="() => (isPopDialog = true)"
                    >{{ $t("POP Graph") }}
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <span>{{ $t("Push to Plantoverview Graph") }}</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
        </Card>
      </v-flex>
    </v-layout>
    <v-flex pl-2 v-if="!showSideBar" xs12 md12 lg12>
      <div class="fill-height main-card">
        <v-tabs :value="activeTab" id="tab" color="primary" grow>
          <v-tab
            key="graph"
            ripple
            class="custom-tab"
            @click="
              showGraph = true;
              showTable = false;
            "
          >
            {{ $t("GRAPHICAL REPORTS") }}
          </v-tab>
          <v-tab
            key="table"
            ripple
            class="custom-tab"
            @click="
              showTable = true;
              showGraph = false;
            "
          >
            {{ $t("TABULAR REPORTS") }}
          </v-tab>
          <v-tab-item key="graph">
            <div flat class="main-card">
              <div v-show="!showGraph" class="image">
                <img
                  src="../assets/file.svg"
                  alt="information"
                  height="20%"
                  width="40%"
                />
                <div class="no_data">
                  <h3>
                    {{
                      $t(
                        "Select Options in order to check data at Plant Level or Device Level"
                      )
                    }}
                  </h3>
                </div>
              </div>
              <div v-show="showGraph" class="echarts">
                <div class="btn-right">
                  <v-tooltip top>
                    <v-btn flat icon slot="activator" @click="loadData">
                      <v-avatar class="avatar-bg">
                        <v-icon>cached</v-icon>
                      </v-avatar>
                    </v-btn>
                    <span>{{ $t("Refresh") }}</span>
                  </v-tooltip>
                </div>
                <div id="photo">
                  <GlobalGraph
                    :key="componentKey"
                    class="graphID"
                    v-if="series.length"
                    :series="computedSeries"
                    :xAxisData="xAxis"
                    :theme="theme"
                    :loading="loading"
                  />
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item key="table">
            <div flat class="main-card">
              <div v-show="!showTable" class="image">
                <img
                  src="../assets/file.svg"
                  alt="information"
                  height="20%"
                  width="40%"
                />
                <div class="no_data">
                  <h3>
                    {{
                      $t(
                        "Select Options in order to check data at Plant Level or Device Level"
                      )
                    }}
                  </h3>
                </div>
              </div>
            </div>
            <div v-if="showTable">
              <div class="btn-right">
                <v-tooltip top>
                  <v-btn flat icon slot="activator" @click="loadData">
                    <v-avatar class="avatar-bg">
                      <v-icon>cached</v-icon>
                    </v-avatar>
                  </v-btn>
                  <span>{{ $t("Refresh") }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-btn flat icon slot="activator" @click="download">
                    <v-avatar class="avatar-bg">
                      <v-icon>get_app</v-icon>
                    </v-avatar>
                  </v-btn>
                  <span>{{ $t("Download CSV") }}</span>
                </v-tooltip>
              </div>
              <RecyclerDataTable
                :items="computedTableData"
                :headers="computedHeader"
                key_field="sensor_time"
                :key="componentKey"
              />
            </div>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-flex>
    <!-- End Side Bar -->
  </v-layout>
</template>

<script>
import moment from "moment";
const momentTz = require('moment-timezone')
import { mapGettersMixin } from "@/util/mixin/index";
import { mapGetters, mapMutations } from "vuex";

import { aggregateParametersList } from "@/services/Analytics.js";
import PlantOverviewAPI from "@/services/PlantOverview";
import AnalyticsService from "@/services/PlantAnalytics.js";

export default {
  mixins: [mapGettersMixin],
  components: {
    RecyclerDataTable: () =>
      import("@/components/utility/RecyclerDataTable.vue"),
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      legendPerCol: 14,
      searchPlant: null,
      searchDevice: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 30) || "Name must be less than 30 characters",
      ],
      dialog: false,
      isPopDialog: false,
      graphName: "",
      graphPosition: "",
      selectTime: false,
      selectInterval: true,
      showFilter: false,
      showSideBar: false,
      showTable: false,
      showGraph: false,
      template: false,
      dateFormat: true,
      open: false,
      resizable: true,
      loading: false,
      isDelete: false,
      snackbar: false,
      kpiList: [],
      analogueList: [],
      templateList: {},
      id: [],
      newId: [],
      selectedDevices: [],
      selectedParameter: [],
      headers: [],
      tableData: [],
      items: [],
      deleteId: "",
      paramItems: [],
      paramNodeSelected: [],
      nodeSelected: {},
      paramOrder: {},
      dialogMessage: "",
      name: "",
      snackbarMessage: "Please Select Parameters",
      level: "",
      activeTab: "graph",
      title: "Save Template",
      snackbarColor: "#3d485d",
      componentKey: 0,
      timeout: 6000,
      compKey: 0,
      timeWhileHover: null,
      param: {
        timeRange: false,
        dateFrom: moment().format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        timeFrom: null,
        timeTo: null,
        interval: 60,
        query: [],
        dateFormat: "YYYY-MM-DD HH:mm",
      },
      plantSelectionOrder: [],
      series: [],
      xAxis: [],
      intervalSelected: 1440,
      activeFilterOptions: {}
    };
  },
  created() {
    this.showGraph = false;
    this.showTable = false;
    this.showSideBar = false;
    this.activeTab = "graph";
    this.getPlantList();
    this.getParameterOrdering();
    this.fetchTemplateList();
  },
  computed: {
    ...mapGetters([
      "getGeneralState",
      "getSelectedPlantId",
      "getPlantName",
      "getUserInfo",
      "getActivePlantTimezone"
    ]),
    currentLanguage() {
      return this.getGeneralState("language");
    },
    theme() {
      return this.isDark ? "dark" : "light";
    },
    filterOption() {
      if (this.level === "device") {
        if (this.isKpi) {
          return [
            {
              id: "Date",
              type: "datePicker",
              title: "Date",
            },
            {
              id: "selectedInterval",
              type: "select",
              title: "Select an Interval",
              value: [
                { text: "5 min", value: 5 },
                { text: "15 min", value: 15 },
                { text: "30 min", value: 30 },
                { text: "1 hr", value: 60 },
                { text: "day", value: 1440 },
              ],
            },
            {
              id: "DateFormat",
              ref: "selectedInterval",
              type: "select",
              title: "Select Date Format",
              value: [
                "YYYY-MM-DD HH:mm",
                "DD-MM-YYYY HH:mm",
                "HH:mm YYYY-MM-DD",
                "HH:mm DD-MM-YYYY",
              ],
              condition: (ref) => !!(ref && ref.value < 61),
            },
            {
              id: "DateFormat",
              ref: "selectedInterval",
              type: "select",
              title: "Select Date Format",
              value: ["YYYY-MM-DD", "DD-MM-YYYY"],
              condition: (ref) => !!(ref && ref.value > 60),
            },
          ]
        } else {
          return [
            {
              id: "Date",
              type: "datePicker",
              title: "Date",
            },
            {
              id: "selectedInterval",
              type: "select",
              title: "Select an Interval",
              value: [
                { text: "1 hr", value: 60 },
                { text: "30 min", value: 30 },
                { text: "15 min", value: 15 },
                { text: "5 min", value: 5 },
                { text: "1 min", value: 1 },
                { text: "day", value: 1440 },
              ],
            },
            {
              id: "selectedTimeInterval",
              ref: "selectedInterval",
              type: "timePicker",
              title: "Select Time Range",
              condition: (ref) => !!(ref && ref.value == 1),
            },
            {
              id: "useTimeRange",
              ref: "selectedInterval",
              type: "checkbox",
              title: "Use time range",
              condition: (ref) => !!(ref && ref.value == 1),
            },
            {
              id: "DateFormat",
              ref: "selectedInterval",
              type: "select",
              title: "Select Date Format",
              value: [
                "YYYY-MM-DD HH:mm",
                "DD-MM-YYYY HH:mm",
                "HH:mm YYYY-MM-DD",
                "HH:mm DD-MM-YYYY",
              ],
              condition: (ref) => !!(ref && ref.value < 61),
            },
            {
              id: "DateFormat",
              ref: "selectedInterval",
              type: "select",
              title: "Select Date Format",
              value: ["YYYY-MM-DD", "DD-MM-YYYY"],
              condition: (ref) => !!(ref && ref.value > 60),
            },
          ]
        }
      } else {
        return [
          {
            id: "Date",
            type: "datePicker",
            title: "Date",
          },
          {
            id: "selectedInterval",
            type: "select",
            title: "Select an Interval",
            value: [{ text: "day", value: 1440 }],
          },
          {
            id: "DateFormat",
            type: "select",
            title: "Select Date Format",
            value: ["YYYY-MM-DD", "DD-MM-YYYY"],
          },
        ];
      }
    },
    selectedInterval() {
      return this.activeFilterOptions.selectedInterval;
    },
    currentDateFormat() {
      return this.activeFilterOptions.DateFormat;
    },
    useTimeRange() {
      return !!this.activeFilterOptions.useTimeRange;
    },
    time() {
      return this.activeFilterOptions.selectedTimeInterval;
    },
    date() {
      return this.activeFilterOptions.Date;
    },
    computedParamItems() {
      const cloneParamItems = _.cloneDeep(this.paramItems);
      return cloneParamItems.map((deviceObj) => {
        deviceObj.name = this.$t(deviceObj.name === "SCB" ? "SMB" : deviceObj.name);
        deviceObj.children = deviceObj.children.map((parameterObj) => {
          parameterObj.name = this.$t(parameterObj.name);
          return parameterObj;
        });
        return deviceObj;
      });
    },
    computedItems() {
      const cloneItems = _.cloneDeep(this.items);
      return cloneItems.map((plantObj) => {
        plantObj.children = plantObj.children.map((devicesObj) => {
          devicesObj.name = this.$t(devicesObj.name === "SCB" ? "SMB" : devicesObj.name);
          return devicesObj;
        });
        return plantObj;
      });
    },
    computedHeader() {
      const cloneHeader = _.cloneDeep(this.headers);
      return cloneHeader.map((el) => {
        let key = "";
        if (el.paramName) {
          key = this.$t(el.paramName);
          el.key = el.key.replace(el.paramName, key);
          el.value = el.key;
        } else {
          key = this.$t(el.text);
          el.key = el.key.replace(el.key, key);
        }
        return el;
      });
    },
    computedTableData() {
      const cloneTableData = _.cloneDeep(this.tableData);
      return cloneTableData.map((rowObj) => {
        const tempRowData = {};
        this.computedHeader.forEach((headerObj) => {
          if (headerObj.text != "Sensor Time") {
            tempRowData[headerObj.key] = rowObj[headerObj.text];
          } else {
            tempRowData[headerObj.value] = rowObj[headerObj.value];
          }
        });
        return tempRowData;
      });
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series);
      return cloneSeries.map((el) => {
        const index = this.computedHeader.findIndex(
          (headerObj) => headerObj.text == el.name
        );
        if (index >= 0) {
          el.name = this.computedHeader[index].key;
        }
        return el;
      });
    },
    isShowPopButton() {
      const deviceListIncluded = [
        "weather station",
        "inverter",
        "mfm",
        "energy meter",
      ];
      const parameterListIncluded = [
        "ac_power",
        "energy",
        "active_total_export_cumulative",
        "irradiance_vertical",
        "irradiance_horizontal",
      ];

      const is1PlantSelected = this.param["query"].length === 1;
      const isPlantSameAsCurrent =
        this.param["query"][0].name ==
        this.getPlantName(this.getSelectedPlantId);
      const is1EquipmentSelected = this.param["query"][0].query.every((el) =>
        deviceListIncluded.includes(el.device)
      );
      const count = {};
      this.param["query"][0].query.forEach((el) => {
        if (el.device == "inverter") {
          count[el.device] = 1;
        } else {
          count[el.device] = (count[el.device] || 0) + 1;
        }
      });
      const isDeviceCountExceeded = Object.values(count).some(
        (value) => value > 2
      );
      const isTotalDeviceCountExceeded =
        Object.values(count).reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0) > 8;

      let isComputableParameterSelected = false;
      if (this.param["query"][0].query[0].param.length > 0) {
        isComputableParameterSelected = this.param["query"][0].query.every(
          (deviceObj) => {
            return deviceObj.param.every((param) =>
              parameterListIncluded.includes(param)
            );
          }
        );
      }

      return (
        is1PlantSelected &&
        isPlantSameAsCurrent &&
        is1EquipmentSelected &&
        !isDeviceCountExceeded &&
        !isTotalDeviceCountExceeded &&
        isComputableParameterSelected
      );
    },
    isKpi() {
      if (this.level == 'kpi') {
        return true
      }

      const types = ["COMPUTED", "DIFF"];
      return this.selectedParameter.some((el) => types.includes(el.type));
    }
  },
  methods: {
    ...mapMutations([
      "SET_PROGRESS_BAR",
    ]),
    levelChange(value) {
      this.showTable = false;
      this.showGraph = false;
      this.selectTime = false;
      this.showSideBar = true;

      if (this.level == value) {
        if (this.items.length == 0) {
          this.items = this.isKpi ? this.kpiList : this.analogueList;
        }

        return;
      }

      this.clearSelection();
      this.level = value;
      let currentDate = momentTz().tz(this.getActivePlantTimezone).format("YYYY-MM-DD");

      if (this.level === "kpi") {
        this.items = this.kpiList;
        currentDate = moment(currentDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
      } else {
        this.items = this.analogueList;
      }

      const Obj = {};
      const cloneFilterOption = _.cloneDeep(this.filterOption);
      cloneFilterOption.forEach((child) => {
        if (
          (child.condition &&
            (!!child.considerStateAlways ||
              child.condition(Obj[child.ref]))) ||
          !child.condition
        ) {
          if (child.type === "select") {
            if (typeof child.value === "function") {
              Obj[child.id] = child.value(Obj[child.ref])[0];
            } else {
              Obj[child.id] = child.value[0];
            }
          } else if (
            child.type === "datePicker" ||
            child.type === "singleDatePicker"
          ) {
            let parameters = ["from", "to"];
            parameters.forEach((key) => {
              if (!Obj[child.id]) {
                Obj[child.id] = {};
              }
              Obj[child.id][key] = currentDate;
            });
          } else {
            Obj[child.id] = child.value;
          }
        }
      });

      this.activeFilterOptions = Obj;
      this.$emit("max:date", currentDate)
      this.$emit("filter:config", cloneFilterOption);
      this.$emit("initial:active_filter", Obj);
      this.$emit("callback:onIntervalChange", this.dateRangeSelectionHandler)
    },
    clearSelection() {
      this.selectedDevices = [];
      this.selectedParameter = [];
      this.paramItems = [];
      this.nodeSelected = {};
      this.paramNodeSelected = {};
      this.param["query"] = [];
      this.series = [];
      this.xAxis = [];
      this.tableData = [];
      this.headers = [];
      this.plantSelectionOrder = [];
      
      this.items = this.level === "kpi" ? this.kpiList : this.analogueList;
      this.compKey++;
    },
    dateRangeSelectionHandler(active) {
      let minimumDateAllowed = '', dateRangeAllowed = 31

      if (
        active["selectedInterval"].value &&
        active["selectedInterval"].value == 1
      ) {
        minimumDateAllowed = momentTz().tz(this.getActivePlantTimezone)
          .subtract(90, "day")
          .format("YYYY-MM-DD");

        dateRangeAllowed = 10;
      } else if (
        active["selectedInterval"].value &&
        active["selectedInterval"].value >= 5
      ) {
        minimumDateAllowed = "";
        dateRangeAllowed = 15;
      } else {
        minimumDateAllowed = "";
        dateRangeAllowed = moment(
          active["Date"]["from"]
        )
          .endOf("month")
          .format("DD");
      }

      return {
        minimumDateAllowed,
        dateRangeAllowed
      }
    },
    templateRules() {
      if (this.templateList[this.level].length >= 5) {
        this.dialogMessage =
          "You can only save upto 5 Templates max.Please remove one of the Pre-saved Template, in order to proceed.";
        this.dialog = true;
      } else {
        this.template = true;
      }
    },
    async insertTemplate() {
      let temp = {};
      Object.assign(temp, this.param);
      temp["name"] = this.name;
      temp["level"] = this.level;
      temp["userId"] = this.getUserInfo("userId")
      let res = await AnalyticsService.insertTemplates(temp);
      if (res.status == 200) {
        this.snackbarMessage = "Template Saved Successfully";
        this.snackbar = true;
        this.fetchTemplateList();
      } else if (res.status == 400) {
        this.snackbarMessage = "Failed to save template!";
        this.snackbar = true;
        this.name = "";
      }
    },
    async sendGraphToPop() {
      if (this.graphName == "" || this.graphPosition == "") {
        this.snackbarMessage = "Please give the proper inputs!";
        this.snackbar = true;
        return;
      }

      const options = {};
      this.param["query"][0].query.forEach((opt) => {
        if (!options[opt.device]) {
          options[opt.device] = {
            deviceDetails: [],
          };
        }

        if (!options[opt.device]["parameter"]) {
          options[opt.device]["parameter"] = opt.param;
        }

        if (!options[opt.device]["deviceType"]) {
          options[opt.device]["deviceType"] = opt.device;
        }

        if (opt.device != "inverter") {
          options[opt.device]["deviceDetails"].push({
            id: opt.id,
            name: opt.name,
          });
        } else {
          options[opt.device]["deviceDetails"] = this.items
            .find((plantObj) => plantObj.id === this.getSelectedPlantId)
            .children.find((equipObj) => equipObj.name == "Inverter")
            .children.map((deviceObj) => {
              return {
                id: deviceObj.device_id,
              };
            });
        }
      });
      let temp = {
        plantId: this.getSelectedPlantId,
        graphName: this.graphName,
        position: this.graphPosition,
        options: Object.values(options),
      };
      let res = await PlantOverviewAPI.sendGraphToPop(temp);
      if (res.status == 200) {
        this.snackbarMessage =
          "Device parameter sent to POP graph successfully";
        this.snackbar = true;
      } else if (res.status == 400) {
        this.snackbarMessage = "Failed to save to POP graph!";
        this.snackbar = true;
      }
    },
    async deleteTemplate() {
      let res = await AnalyticsService.deleteTemplate(this.deleteId);
      if (res.status == 200) {
        this.snackbarMessage = "Template Deleted Successfully";
        this.snackbar = true;
        this.fetchTemplateList();
      } else if (res.status == 400) {
        this.snackbarMessage = "Failed to delete template!";
        this.snackbar = true;
      }
    },
    async fetchTemplateList() {
      this.templateList = {
        device: [],
        kpi: [],
      };
      let res = await AnalyticsService.fetchTemplate(
        this.getUserInfo("userId")
      );
      if (res.status == 200) {
        res.data.list.forEach((el) => {
          if (el.name !== undefined && el.level !== undefined) {
            this.templateList[el.level].push({
              text: el.name,
              value: el.analytics,
              id: el._id,
            });
          }
        });
      }
    },
    templateSelected(template, item) {
      if (template.length === 0) {
        this.series = [];
        this.tableData = [];
        this.headers = [];
        this.showTable = false;
        this.showGraph = false;
        this.param["query"] = [];
      } else {
        this.param["query"] = template;
        this.loadData();
      }
      this.compKey++;
    },
    async getPlantList() {
      this.SET_PROGRESS_BAR(true);
      let res = await AnalyticsService.getPlantList();
      this.SET_PROGRESS_BAR(false);

      if (res.status == 200) {
        this.kpiList = res.data;
        this.analogueList =res.data;
      }
    },
    async fetchPlantDeviceConfig(selected) {
      if (selected.level === "plant") {
        const response = await AnalyticsService.getPlantEquipmentList(
          selected.id,
          this.isKpi ? 'kpi' : 'device'
        );
        const deviceList = response.data;

        this.items = this.items.map(item => {
          if (item.id === selected.id) {
            return {
              ...item,
              children: [...deviceList]
            }
          }
          return item
        })
      } else if (selected.level == 'device') {
        const response = await AnalyticsService.getDeviceList({ equipmentList: [{ plantId: selected.plantId, device: selected.device, level: selected.level }] });
        const deviceListIds = response.data;

        Object.keys(deviceListIds).forEach(p => {
          const index = this.items.findIndex(item => item.id == p)

          this.items[index].children = this.items[index].children.map(child => {
            if (deviceListIds[p][child.device]) {
              return {
                ...child,
                children: deviceListIds[p][child.device].map(el => ({
                  ...el
                }))
              }
            }
            return child
          })
        })
      }
    },
    async getParameterOrdering() {
      let res = await AnalyticsService.fetchParameterOrder(
        this.getUserInfo("userId")
      );
      if (res.status == 200) {
        this.paramOrder = res.data.result.length > 0 ? res.data.result[0].list : {};
      } else {
        console.log("Could not fetch parameter ordering for the userId");
      }
    },
    async getParameterList() {
      Object.entries(this.nodeSelected).forEach(([device, value]) => {
        Object.entries(value).forEach(async ([plantId, idList]) => {
          let parameterParam = {
            plantId,
            device,
            idList,
            options: {
              ignore: {
                key: "type",
                value: "ref",
              },
            },
          };
          let param64 = btoa(JSON.stringify(parameterParam));
          let paramList = await aggregateParametersList(param64);
          let paramStructure = paramList.data.filter((item) => {
            item["device"] = device;
            item["id"] = `${device}:${item.key}:${item.label}`;
            item["name"] = item.label;
            return item;
          });
          let paramItemOrder = _.groupBy(this.paramItems, (item) => item.id);
          if (paramItemOrder[device] == undefined && this.nodeSelected[device][plantId].length > 0) {
            this.paramItems.push({
              name: device.toUpperCase(),
              id: device,
              children: paramStructure,
            });
          } // when deselected remove
          else {
            this.paramItems.forEach((el) => {
              if (el.id == device) {
                el["children"] = paramStructure;
              }
            });
          }
          // To Order Parameters Based On Configuration
          this.paramItems.forEach((el, index) => {
            if (!Object.keys(this.nodeSelected).includes(el.id)) {
              this.paramItems.splice(index, 1);
            }
            let keyOrder = this.paramOrder[el.id];
            if (keyOrder !== undefined) {
              let temp = [];
              let ordered = _.groupBy(el.children, (item) => item.key);
              keyOrder.forEach((key, index) => {
                if (ordered[key] !== undefined) {
                  temp[index] = ordered[key][0];
                }
              });
              el.children = _.unionBy(temp, el.children, "key").filter((el) => {
                if (el !== undefined) return el;
              });
            }
          });
        });
      });
      this.getParameterQuery();
    },
    getParameterQuery() {
      this.param["query"].length = 0;
      
      if (
        Object.keys(this.nodeSelected).length !== 0 &&
        Object.keys(this.paramNodeSelected).length !== 0
      ) {
        Object.entries(this.nodeSelected).forEach(([device, value]) => {
          Object.entries(value).forEach(([plantId, id]) => {
            this.items.forEach((el) => {
              if (
                el.id == plantId &&
                Object.keys(this.paramNodeSelected).includes(
                  device.toLowerCase()
                )
              ) {
                let temp = {
                  plantId,
                  name: el.name,
                  query: [],
                };
                el.children.forEach((i) => {
                  if (
                    Object.keys(this.paramNodeSelected).includes(
                      i.name.toLowerCase()
                    ) &&
                    Object.keys(this.paramNodeSelected).includes(
                      device.toLowerCase()
                    )
                  ) {
                    if (i.children !== undefined) {
                      // children is not available for kpi
                      i.children.forEach((item) => {
                        if (
                          id.includes(item.device_id) &&
                          i.name.toLowerCase() === device
                        ) {
                          temp["query"].push({
                            device,
                            id: item.device_id,
                            name: item.name,
                            param: this.paramNodeSelected[device]["param"],
                            paramName:
                              this.paramNodeSelected[device]["paramName"],
                          });
                        }
                      });
                    } else {
                      Object.entries(this.paramNodeSelected[device]).forEach(
                        ([source, list]) => {
                          temp["query"].push({
                            device,
                            id: i.device_id,
                            name: i.name,
                            param: list["param"],
                            paramName: list["paramName"],
                            source,
                          });
                        }
                      );
                    }
                  }
                });

                let groupParam = _.groupBy(
                  this.param["query"],
                  (item) => item.plantId
                );
                if (Object.keys(groupParam).includes(plantId)) {
                  let index = this.param["query"].findIndex(
                    (i) => i.plantId === plantId
                  );
                  this.param["query"][index]["query"].push(...temp.query);
                } else {
                  this.param["query"].push(temp);
                }
              }
            });
          });
        });
      }
    },
    async loadData() {
      if (this.param["query"].length !== 0) {
        this.param["interval"] = this.activeFilterOptions.selectedInterval.value;
        this.param["plantSelectionOrder"] = this.plantSelectionOrder
        this.loading = true;
        let res = await AnalyticsService.getPlantData(this.param);
        this.loading = false;
        if (res.status == 200) {
          this.tableData = res.data.message.data;
          this.headers = res.data.message.headers;
          this.series = res.data.message.series;
          this.xAxis = res.data.message.xAxis[0].data;
          this.componentKey += 1;
        } else if (res.status == 400) {
          this.tableData = [];
          this.headers = [];
          this.series = [];
          this.xAxis = [];
          this.componentKey += 1;
        }
        this.showSideBar = false;
        this.showGraph = true;
      }
    },
    async download() {
      if (this.param["query"].length === 0) {
        this.snackbarMessage = "Please Select Plant/Parameters";
        this.snackbar = true;
      } else {
        let param64 = btoa(
          unescape(encodeURIComponent(JSON.stringify(this.param)))
        );
        await AnalyticsService.downloadPlantTableData(param64);
      }
    },
    async handleSelectionChange(selectedItems) {
      const isPlantLevel = Array.isArray(selectedItems) && selectedItems.some(el=> el.level === "plant");
      if (!this.isKpi && isPlantLevel) {
        const selectedEquipmentList = selectedItems.filter(item => item.level != 'plant').map(item => { return { plantId: item.plantId, level: item.level, device: item.device } });
        const response = await AnalyticsService.getDeviceList({ equipmentList: selectedEquipmentList });
        const deviceListIds = response.data;

        Object.keys(deviceListIds).forEach(p => {
          const index = this.items.findIndex(item => item.id == p)

          this.items[index].children = this.items[index].children.map(child => {
            if (deviceListIds[p][child.device]) {
              return {
                ...child,
                children: deviceListIds[p][child.device].map(el => ({
                  ...el
                }))
              }
            }
            return child
          })
        })
      }
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilterOptions = val;
      },
      deep: true,
    },
    activeFilterOptions: {
      handler(val) {
        this.param["timeRange"] = this.useTimeRange;
        if (this.selectedInterval.value === 1 && this.useTimeRange) {
          this.param["timeFrom"] = this.time.from;
          this.param["timeTo"] = this.time.to;
        }

        if (this.selectedInterval.value !== 1) {
          this.selectTime = false;
        } else {
          this.selectTime = true;
        }
        this.intervalSelected = this.selectedInterval.value;
        this.param["interval"] = this.selectedInterval.value;

        this.param["dateFormat"] = this.currentDateFormat;

        this.param["dateFrom"] = this.date.from;
        this.param["dateTo"] = this.date.to;
        if (this.showTable || this.showGraph) {
          this.loadData();
        }
      },
      deep: true,
    },
    isKpi() {
      let currentDate = momentTz().tz(this.getActivePlantTimezone).format("YYYY-MM-DD");

      if (this.level === "kpi") {
        currentDate = moment(currentDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
      }

      const Obj = {};
      const cloneFilterOption = _.cloneDeep(this.filterOption);
      cloneFilterOption.forEach((child) => {
        if (
          (child.condition &&
            (!!child.considerStateAlways ||
              child.condition(Obj[child.ref]))) ||
          !child.condition
        ) {
          if (child.type === "select") {
            if (typeof child.value === "function") {
              Obj[child.id] = child.value(Obj[child.ref])[0];
            } else {
              Obj[child.id] = child.value[0];
            }
          } else if (
            child.type === "datePicker" ||
            child.type === "singleDatePicker"
          ) {
            let parameters = ["from", "to"];
            parameters.forEach((key) => {
              if (!Obj[child.id]) {
                Obj[child.id] = {};
              }
              Obj[child.id][key] = currentDate;
            });
          } else {
            Obj[child.id] = child.value;
          }
        }
      });

      this.activeFilterOptions = Obj;
      this.$emit("max:date", currentDate)
      this.$emit("filter:config", cloneFilterOption);
      this.$emit("initial:active_filter", Obj);
    },
    showGraph() {
      if (this.showGraph && this.param["query"].length === 0) {
        this.snackbarMessage = "Please Select Plant/Parameters";
        this.snackbar = true;
        this.showGraph = false;
      }
    },
    showTable() {
      if (this.showTable && this.param["query"].length === 0) {
        this.snackbarMessage = "Please Select Plant/Parameters";
        this.snackbar = true;
        this.showTable = false;
      }
    },
    selectedDevices() {
      this.nodeSelected = {};
      if (this.selectedDevices.length !== 0) {
        this.selectedDevices.forEach((el) => {
          if (!Object.keys(el).includes("children")) {
            let plantId = el.plantId;
            if (el.device == "kpi") {
              [plantId,] = el.id.split(":");
            }
            this.nodeSelected[el.device] = !this.nodeSelected.hasOwnProperty(
              el.device
            )
              ? {}
              : this.nodeSelected[el.device];
            if(!this.plantSelectionOrder.includes(plantId))
              this.plantSelectionOrder.push(plantId)
            this.nodeSelected[el.device][plantId] =
              this.nodeSelected[el.device][plantId] == undefined
                ? []
                : this.nodeSelected[el.device][plantId];
            this.nodeSelected[el.device][plantId].push(el.device == 'kpi' ? el.id : el.device_id);
          }
        });
        this.getParameterList();
      } else {
        this.paramItems = [];
      }
    },
    selectedParameter() {
      this.paramNodeSelected = {};
      this.param["query"].length = 0;
      if (this.selectedParameter.length !== 0) {
        this.selectedParameter.forEach((el) => {
          if (!Object.keys(el).includes("children")) {
            this.paramNodeSelected[el.device] =
              !this.paramNodeSelected.hasOwnProperty(el.device)
                ? {}
                : this.paramNodeSelected[el.device];
            if (el.device == "kpi") {
              this.paramNodeSelected[el.device][el.source] = !Object.keys(
                this.paramNodeSelected[el.device]
              ).includes(el.source)
                ? {}
                : this.paramNodeSelected[el.device][el.source];
              this.paramNodeSelected[el.device][el.source]["param"] =
                !Object.keys(
                  this.paramNodeSelected[el.device][el.source]
                ).includes("param")
                  ? []
                  : this.paramNodeSelected[el.device][el.source]["param"];
              this.paramNodeSelected[el.device][el.source]["paramName"] =
                !Object.keys(
                  this.paramNodeSelected[el.device][el.source]
                ).includes("paramName")
                  ? []
                  : this.paramNodeSelected[el.device][el.source]["paramName"];
              if (
                !this.paramNodeSelected[el.device][el.source]["param"].includes(
                  el.key
                )
              ) {
                this.paramNodeSelected[el.device][el.source]["param"].push(
                  el.key
                );
              }
              if (
                !this.paramNodeSelected[el.device][el.source][
                  "paramName"
                ].includes(el.label)
              ) {
                this.paramNodeSelected[el.device][el.source]["paramName"].push(
                  el.label
                );
              }
            } else {
              this.paramNodeSelected[el.device]["param"] = !Object.keys(
                this.paramNodeSelected[el.device]
              ).includes("param")
                ? []
                : this.paramNodeSelected[el.device]["param"];
              this.paramNodeSelected[el.device]["paramName"] = !Object.keys(
                this.paramNodeSelected[el.device]
              ).includes("paramName")
                ? []
                : this.paramNodeSelected[el.device]["paramName"];
              if (
                !this.paramNodeSelected[el.device]["param"].includes(el.key)
              ) {
                this.paramNodeSelected[el.device]["param"].push(el.key);
              }
              if (
                !this.paramNodeSelected[el.device]["paramName"].includes(
                  el.label
                )
              ) {
                this.paramNodeSelected[el.device]["paramName"].push(el.label);
              }
            }
          }
        });
        this.getParameterQuery();
      } else {
        this.paramNodeSelected = {};
        this.param["query"].length = 0;
      }
    },
  },
};
</script>

<style scoped>
.custom-tab:hover {
  background-color: var(--v-sixth-base);
}

.graphID {
  width: 96%;
  height: 440px;
}

.vertical-button-container {
  margin-left: -12px;
  display: flex;
  flex-direction: column;
}

.vertical-button {
  font-size: 15px;
  transform: rotate(180deg);
  background-color: var(--v-sixth-base);
  writing-mode: vertical-rl;
  text-orientation: sideways;
  white-space: nowrap;
  padding: 8px 4px;
  margin: 10px;
  height: auto;
}

.vertical-button:hover {
  cursor: pointer;
}

.theme--light .divison {
  background-color: black !important;
}

.theme--dark .divison {
  background-color: white !important;
}

.kpi-note {
  margin: 26px;
}

.save-template-buttons {
  margin-right: 36px;
}

.search-area {
  background-color: var(--v-secondary-base);
}

#photo {
  padding: 4px;
  height: inherit;
}

.expanded_icon {
  border-color: transparent transparent transparent orange;
  margin-right: 5px;
}

ul,
ol {
  padding-left: 0px;
}

.stand:hover {
  transform: scale(1.5);
}

#mySidenav {
  top: 64px;
  position: fixed;
  right: -12px;
  transition: 0.2s;
  width: 47px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 5px 0 0 5px;
  background-color: #fbbc05;
  z-index: 11;
  cursor: pointer;
}

#mySidenav .icon:hover {
  right: 0;
  transform: scale(1.2);
}

.open-sidenav {
  right: 390px !important;
}

.icon {
  height: 16px;
  width: 24px;
  margin-top: 8px;
  margin-left: 4px;
}

#about {
  top: 4px;
  background-color: #fbbc05;
}

.echarts {
  width: 100%;
  height: 470px;
}

.list_beautify {
  cursor: pointer;
  border-bottom: 1px solid;
}

.theme--light .dialog2 {
  padding: 15px;
  margin-top: 30px;
  /* background-color: #fff !important; */
  border-radius: 14px;
}

.theme--dark .dialog2 {
  text-align: center;
  padding: 15px;
  margin-top: 30px;
  /* background-color: #1a1d34 !important; */
  border-radius: 14px;
}

.theme--dark .dialog2 img {
  text-align: center;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
}

.theme--light .dialog2 img {
  text-align: center;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
}

.dialog2 .overlay-img {
  text-align: center;
  margin-top: -30px;
  margin-bottom: 15px;
}

.alert-loudspeaker {
  height: 100px;
  display: flex;
  margin-top: 30px;
}

.dialog {
  border-radius: 8px;
}

.equipment-img {
  text-align: center;
  cursor: pointer;
}

.equipment-subtext {
  color: #fbbc05;
  font-size: 16px;
}

/* .theme--dark .param{
    color: #b1b4b9;
  }
  .theme--light .param{
    color: #000;
  }     */
.theme--dark .selected-background {
  /* background-color: #17192c; */
  padding: 10px;
}

.theme--light .selected-background {
  /* background-color: #e1e1e1; */
  padding: 10px;
}

.main-background {
  margin-bottom: 4px;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 70px;
  /* background-color: black;
    color: #fff; */
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 12px;
  right: 48px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* .echarts {
    width:100%;
    height: 470px;
  } */
.btn-right {
  text-align: end;
}

.btn-centre {
  text-align: center;
}

.submit {
  margin-top: 190%;
}

.apply {
  margin-top: 198%;
}

.image {
  text-align: center;
  margin-top: 40px;
}

.ntb {
  margin: 0px;
  margin-right: 4px;
  height: 30px;
}

.tree {
  margin: 5px;
  min-height: 410px;
  max-height: 410px;
  overflow-x: hidden;
  overflow-y: auto;
  /* background-color: #1a1d34 !important; */
}

.trees {
  margin: 5px;
  min-height: 500px;
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
  /* background-color: #1a1d34 !important; */
}

/* 80% responsiveness */
@media only screen and (min-width: 1904px) and (max-width: 2544px) {
  .theme--dark .trees {
    margin: 5px;
    min-height: 691px;
    max-height: 691px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #242c50 !important; */
  }

  .theme--light .trees {
    margin: 5px;
    min-height: 691px;
    max-height: 691px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .theme--dark .tree {
    margin: 5px;
    min-height: 704px;
    max-height: 704px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #242c50 !important; */
  }

  .theme--light .tree {
    margin: 5px;
    min-height: 704px;
    max-height: 704px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .selected_item_data-header {
    height: 52px;
  }

  p {
    font-size: 22px;
  }
}

/* 80% responsiveness */

/* 90% responsiveness */
@media only screen and (min-width: 1584px) and (max-width: 1904px) {
  .theme--dark .trees {
    margin: 5px;
    min-height: 590px;
    max-height: 590px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #212c50 !important; */
  }

  .theme--dark .tree {
    margin: 5px;
    min-height: 607px;
    min-height: 607px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #212c50 !important; */
  }

  .theme--light .trees {
    margin: 5px;
    min-height: 590px;
    max-height: 590px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .theme--light .tree {
    margin: 5px;
    min-height: 607px;
    min-height: 607px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .selected_item_data-header {
    height: 50px;
  }

  p {
    font-size: 18px;
  }
}

/* 90% responsiveness */

/* 100% responsiveness */
@media only screen and (min-width: 1394px) and (max-width: 1585px) {
  .theme--dark .trees {
    margin: 5px;
    min-height: 521px;
    max-height: 521px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #212c50 !important; */
  }

  .theme--dark .tree {
    margin: 5px;
    min-height: 513px;
    min-height: 535px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #212c50 !important; */
  }

  .theme--light .trees {
    margin: 5px;
    min-height: 521px;
    max-height: 521px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .theme--light .tree {
    margin: 5px;
    min-height: 535px;
    min-height: 535px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .equipment_data {
    min-height: 627px;
    max-height: 627px;
  }
}

/* 100% responsiveness */

/* 110% responsiveness */
@media only screen and (min-width: 1280px) and (max-width: 1432px) {
  .theme--dark .trees {
    margin: 5px;
    min-height: 451px;
    max-height: 451px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #212c50 !important; */
  }

  .theme--dark .tree {
    margin: 5px;
    min-height: 465px;
    min-height: 465px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #212c50 !important; */
  }

  .theme--light .trees {
    margin: 5px;
    min-height: 451px;
    max-height: 451px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .theme--light .tree {
    margin: 5px;
    min-height: 465px;
    min-height: 465px;
    overflow-x: hidden;
    overflow-y: auto;
    /* background-color: #fff !important; */
  }

  .parameter_data {
    height: 560px;
  }

  .equipment_data {
    min-height: 558px;
  }
}

/* 110% responsiveness */
</style>
<style>
#overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
}
</style>
